import { getStatuses } from '../../../../services/utils/leads';
import { isQacLeadBlocked } from '../../../../services/utils/contactSource';
import * as types from './types';

const initialState = {
  posting: undefined,
  lead: {},
  phones: undefined,
  statuses: [],
  emailVerification: {},
  phoneVerification: [],
  loading: 'loading',
  loadingStatus: 'loading',
  loadingFeedback: '',
  snackBar: { show: false },
  snackBarLeadDetail: { show: false },
  id: '',
  document: undefined,
  ask_feedback: undefined,
  feedbackLink: undefined,
  show_ask_feedback: undefined,
  feedback_warning: undefined,
  MessageAttachment: {},
  smartLead: {},
  lead_info: {},
  scoreLead: {},
  renterProfile: {},
  related: [],
  customAnswers: undefined,
  phoneSelected: {},
  customAnswerStatus: { response: undefined },
  contactResponseStatus: [],
  contacPublisherUserid: '',
  leadStatus: [],
  emailStatus: true,
  isQacLead: false
};

const InfoLeadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LEAD_INFO:
      return {
        ...state,
        lead: {},
        MessageAttachment: {},
        loading: 'loading',
        phones: undefined,
        phoneVerification: [],
        document: undefined,
        phoneSelected: {},
        ask_feedback: false,
        show_ask_feedback: false,
        feedbackLink: undefined,
        loadingFeedback: false,
        contactResponseStatus: {},
        contacPublisherUserid: '',
        feedback_warning: undefined,
        emailStatus: true,
        isQacLead: false
      };
    case types.FETCH_LEAD_INFO_SUCCEEDED:
      return {
        ...state,
        id: action.payload.id,
        posting: action.payload.posting,
        statuses: action.payload.statuses || [],
        lead: action.payload.lead_user,
        phones: action.payload.phone_list,
        document: action.payload.dni,
        ask_feedback: action.payload.ask_feedback,
        show_ask_feedback: action.payload.show_ask_feedback,
        feedbackLink: action.payload.feedback_questionary_url || undefined,
        contactResponseStatus: action.payload.contact_response_status,
        contacPublisherUserid: action.payload.contact_publisher_user_id,
        feedback_warning: action.payload.feedback_warning || undefined,
        isQacLead: isQacLeadBlocked(action.payload.actions),
        loading: 'loaded',
        loadingFeedback: true,
        emailStatus: true
      };

    case types.FETCH_LEAD_INFO_FAILED:
      return {
        ...state,
        loading: 'error'
      };
    case types.FETCH_EMAIL_VALIDATION_SUCCEEDED:
      return {
        ...state,
        emailVerification: action.payload
      };

    case types.FETCH_LEADS_ETIQUETAS_SUCCEEDED:
      return {
        ...state,
        leadStatus: action.payload
      };

    case types.FETCH_EMAIL_VALIDATION_NO_DATA:
      return {
        ...state,
        emailVerification: {}
      };

    case types.FETCH_PHONE_VALIDATION_SUCCEEDED:
      state.phoneVerification.push(action.payload);
      return { ...state };

    case types.FETCH_PHONE_VALIDATION_RESET:
      return {
        ...state,
        phoneVerification: {}
      };

    case types.UPDATE_LEAD_STATUS:
      return {
        ...state,
        loadingStatus: 'loading'
      };

    case types.FETCH_SEND_EMAIL_ERROR:
      return {
        ...state,
        emailStatus: false
      };

    case types.UPDATE_LEAD_STATUS_SUCCEEDED:
      state.loadingStatus = 'loaded';
      state.statuses = state.statuses.filter(s => s !== getStatuses(action.payload));
      state.statuses.push(action.payload);
      return { ...state };
    /* return {
        aqui tenemos que mejorar la asignacion de este reducer
         todo se tiene que manejar dentro de este bloque de code
        ...state,
        loadingStatus:'loaded',
        statuses:  state.statuses.filter(s => s !== getStatuses(action.payload)),
        statuses:action.payload
      }; */

    case types.UPDATE_LEAD_STATUS_FAILED:
      return {
        ...state,
        loadingStatus: 'error'
      };
    case types.FETCH_SMARTLEAD_SUCCEEDED:
      return {
        ...state,
        smartLead: action.payload || {}
      };

    case types.FETCH_SMARTLEAD_RESET:
      return {
        ...state,
        smartLead: {}
      };

    case types.FETCH_FEEDBACK_RESET:
      return {
        ...state,
        loadingFeedback: false,
        show_ask_feedback: false,
        feedbackLink: undefined
      };

    case types.FETCH_RENTERPROFILE_RESET:
      return {
        ...state,
        renterProfile: {}
      };

    case types.FETCH_SCORELEAD_SUCCEEDED:
      return {
        ...state,
        scoreLead: action.payload
      };

    case types.FETCH_RENTERPROFILE_SUCCEEDED:
      return {
        ...state,
        renterProfile: action.payload
      };

    case types.FETCH_RENTERPROFILE_FAILED:
      return {
        ...state,
        renterProfile: {}
      };

    case types.FETCH_SCORELEAD_NOPOSTING:
      return {
        ...state,
        scoreLead: {}
      };
    case types.FETCH_RELATED_SUCCEEDED:
      return {
        ...state,
        related: action.payload
      };

    case types.FETCH_MESSAGEATTACHEMENTS_SUCCEEDED:
      return {
        ...state,
        MessageAttachment: action.payload
      };

    case types.FETCH_MESSAGEATTACHEMENTS_FAILED:
      return {
        ...state,
        MessageAttachment: {}
      };

    case types.SHOW_SNACKBAR:
      state.snackBar = action.payload;
      state.snackBar.show = true;
      return { ...state };
    case types.HIDE_SNACKBAR:
      state.snackBar = { ...state.snackBar, show: false };
      return { ...state };
    case types.SHOW_SNACKBAR_LEAD_DETAIL:
      state.snackBarLeadDetail = action.payload;
      state.snackBarLeadDetail.show = true;
      return { ...state };
    case types.HIDE_SNACKBAR_LEAD_DETAIL:
      state.snackBarLeadDetail = { ...state.snackBar, show: false };
      return { ...state };

    case types.FETCH_CUSTOM_ANSWERS:
      state.customAnswers = action.payload;
      return { ...state };

    case types.FETCH_CUSTOM_ANSWER_STATUS:
      state.customAnswerStatus = { response: action.payload };
      return { ...state };
    case types.FETCH_CUSTOM_ANSWER_RESET:
      state.customAnswerStatus = { response: undefined };
      return { ...state };

    case types.SELECTED_PHONE:
      state.phoneSelected = action.payload;
      return { ...state };

    case types.FETCH_LEADS_ETIQUETAS_CHANGUE:
      state.contactResponseStatus = action.payload;
      return { ...state };

    default:
      return { ...state };
  }
};

export default InfoLeadReducer;
